export default {
	props: {
		options: {
			type: Array,
			default: () => []
		}
	},

	data() {
		return {
			selectDefaultValue: null
		};
	},
	computed: {
		selectOptions() {
			if (this.gestiosField) {
				const options = [];
				const vars = this.gestiosField.Vars ? JSON.parse(this.gestiosField.Vars) : [];
				vars.forEach((opt) => {
					options.push({ key: opt.id.toString(), label: opt.name });
				});

				if (options.length > 0) return options;
			}

			return this.options;
		}
	},
	methods: {
		selectChange(value) {
			this.$emit('input', this.parseValue(value));
		},
		selectParseValue(value) {
			switch (typeof value) {
				case 'number':
				case 'string':
					return value.toString();

				default:
					return this.selectParseDefaultValue();
			}
		},
		selectParseDefaultValue() {
			let defaultValue = this.selectDefaultValue;

			if (this.defaultValue !== null) {
				if (typeof this.defaultValue === 'object') {
					if (this.defaultValue.key !== undefined && this.defaultValue.label !== undefined) {
						defaultValue = {
							key: this.defaultValue.key,
							label: this.defaultValue.label,
							data: this.defaultValue
						};
					}
				}
			}

			return defaultValue;
		}
	}
};
